import { CONFIG } from "../../config";

const orderResults = (results) => {
    if (CONFIG.ORDER_BY !== 'date') {
        return results;
    }

    const getDate = (obj) => obj?.__date ?? 0;

    results.hits = results.hits.sort((a, b) => {
        return getDate(b) - getDate(a);
    });

    return results;
};

export default orderResults;